// CustomerTable.jsx
const CustomerTable = ({ guestInfo }) => {
    return (
        <div className="table-responsive">
            <table className="table table-sm table-bordered mb-0">
                <tbody>
                    {guestInfo?.map((data, index) => (
                        Object.keys(data).map((key, subIndex) => (
                            <tr key={index + "-" + subIndex}>
                                <th scope="row">{key}</th>
                                <td>{data[key]}</td>
                            </tr>
                        ))
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const CustomTable = ({ columns, data }) => {
    return (
      <table className="table table-bordered mb-0">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx}>{col.Header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, colIndex) => (
                <td key={colIndex}>{row[col.accessor]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  

export  {CustomerTable,CustomTable};
